interface ProgressBarProps {
  steps: string[];
  active: number;
}

export function ProgressBar({ steps, active }: ProgressBarProps) {
  return (
    <div
      style={{
        padding: '14px 20px 12px',
        background: 'var(--bg-card)',
        borderBottom: '1px solid var(--line-soft)',
      }}
    >
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        {steps.map((_, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: 3,
              borderRadius: 2,
              background: i <= active ? 'var(--terracotta)' : 'var(--line)',
            }}
          />
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 10,
          color: 'var(--ink-mute)',
          fontFamily: 'var(--mono)',
          letterSpacing: 0.5,
        }}
      >
        <span>
          Schritt {active + 1} von {steps.length}
        </span>
        <span style={{ color: 'var(--ink-soft)', fontWeight: 600 }}>{steps[active]}</span>
      </div>
    </div>
  );
}
